<script setup>
import { buildDefaultNewFeeLocation } from '@/components/operational/newFee/newFeeTabs'

definePage({
  name: 'operational-new-fee',
  path: '/operational/newFee',
})

const route = useRoute()
const router = useRouter()

router.replace(buildDefaultNewFeeLocation(route))
</script>

<template>
  <div />
</template>
